interface FilterPendingBadgeProps {
    show: boolean;
}

export function FilterPendingBadge({show}: FilterPendingBadgeProps) {
    if (!show) return null;
    return (
        <span
            className="flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-amber-600"
            title="Niet-toegepaste wijzigingen"
        >
            <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true"/>
            Niet toegepast
        </span>
    );
}
